import { makeAutoObservable } from 'mobx';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { ProductLineAttr } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import CartItemDelegate from './cartItemDelegate';

interface DomainData {
  productLineId: ProductLineId;
  cartItemDelegates: CartItemDelegate[];
  productLineAttributes: ProductLineAttr[];
}

export default class ProductLineDelegate {
  private _productLineId: ProductLineId | null;
  private _cartItemDelegates: CartItemDelegate[] = [];
  private _productLineAttributes: ProductLineAttr[] = [];

  public get cartItemDelegates(): CartItemDelegate[] {
    return this._cartItemDelegates;
  }

  public get productLineId(): ProductLineId {
    if (!this._productLineId) {
      throw new Error('ProductLineDelegate initiated without product line id!');
    } else {
      return this._productLineId;
    }
  }

  public get productLineAttributes(): ProductLineAttr[] {
    return this._productLineAttributes;
  }

  constructor({ productLineId, cartItemDelegates, productLineAttributes }: DomainData) {
    this._productLineId = productLineId;
    this._cartItemDelegates = cartItemDelegates;
    this._productLineAttributes = productLineAttributes;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
